/**
 * @file NotFoundPage.tsx
 * @description 404 fallback. Self-contained, no API calls.
 * @module Pages
 * @security Renders only i18n strings; no user input echoed.
 */

import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-3xl font-bold text-slate-900">{t('notfound.title')}</h1>
        <p className="text-slate-500">{t('notfound.subtitle')}</p>
        <Link to="/" className="text-sm text-brand-strong hover:underline">
          {t('notfound.home_link')}
        </Link>
      </div>
    </main>
  );
}
